import { NgModule } from '@angular/core';
import { TemplateCustomFieldComponent } from './template-field/template-custom-field.component';
import { TemplateCustomGroupComponent } from './template-group/template-custom-group.component';
import { TemplateCustomContainerComponent } from './template-container/template-custom-container.component';
import { TemplateCustomFieldsService } from './services/template-custom-fields.service';
import { CustomFieldModalModule } from '../custom-field-modal/custom-field-modal.module';
import { TemplateGroupModalModule } from './template-group-modal/template-group-modal.module';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { TemplateGroupUndeletableModalComponent } from './template-group-undeletable-modal/template-group-undeletable-modal.component';
import { CardModule, PageHeaderModule, NgxDnDModule } from '@certemy/ui-components';
import { NgbCustomModalModule } from 'components/modal-windows/ngb-custom-modal/ngb-custom-modal.module';
import { CustomModalModule } from 'components/custom-modal/custom-modal.module';

@NgModule({
  imports: [
    CertemyCommonModule,
    CustomFieldModalModule,
    TemplateGroupModalModule,
    PageHeaderModule,
    CardModule,
    NgbCustomModalModule,
    CustomModalModule,
    NgxDnDModule,
  ],
  declarations: [
    TemplateCustomFieldComponent,
    TemplateCustomGroupComponent,
    TemplateCustomContainerComponent,
    TemplateGroupUndeletableModalComponent,
  ],
  providers: [TemplateCustomFieldsService],
})
export class TemplateCustomFieldsModule {}
